export enum SharedReportDetailsEnum {
    name,
    title,
    createdBy,
    dateCreated,
    sourceReport,
    url
}
